export const validateEmail = (val: string) => {
        if (!val) return 'Email is required';
        // simple email regex
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(val) ? null : 'Enter a valid email address';
    };

    export const validateFullname = (val: string) => {
        if (!val) return 'Full name is required';
        if (val.trim().length < 3) return 'Full name must be at least 3 characters';
        return null;
    };
    export const validateOrganisation = (val: string, name:string) => {
        if (!val) return `${name} is required`;
        if (val.trim().length < 3) return `${name} must be at least 3 characters`;
        return null;
    };
